<template>
    <div v-if="pgLoading" class="loadingLogo">
        <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
    </div>
    <div v-else class="">
        <Banner :background="info.image ? info.image.url : ''" :title="!pgLoading ? $t('app.categories') : ''"
            :subtitle="!pgLoading ? $t('app.categories') : ''">
        </Banner>

        <section class="events-grid-area pt-50 pb-50">
            <div class="container">
                <div v-if="pgLoading" class="row g-5">
                    <div v-for="(item, idx) in 6" :key="idx" class="col-xl-4 col-lg-4 col-md-6">
                        <div class="events-02 pos-rel mb-30 wow fadeInUp2 animated webkit-animation webkit-none-270">
                        </div>
                    </div>
                </div>

                <div v-if="!pgLoading" class="project-cards-grid">
                    <ProjectCard v-for="(row, idx) in rows" :key="idx" :row="row" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "List",
    components: {
        Banner: () => import("@/components/Banner.vue"),
        ProjectCard: () => import("@/components/ProjectCard.vue"),
    },
    data() {
        return {
            //
            rows: [],
            locale: "ar",
            pgLoading: true,
            info: "",
            categories: [],

            currentPage: 1,
            itemsPerPage: 9,
            resultCount: 0,
            nextPage: 2,
            prevPage: 0,
        };
    },
    computed: {
        totalPages: function () {
            return Math.ceil(this.resultCount / this.itemsPerPage);
        },
    },
    mounted() { },
    created() {
        //
        if (localStorage.getItem("locale")) {
            this.locale = localStorage.getItem("locale");
        }

        this.fetchData();
    },
    watch: {
        '$route.params.id': {
            immediate: true, // fetch immediately on component load
            handler(newId) {
                if (newId) {
                    this.fetchData(newId);
                }
            }
        }
    },
    methods: {
        //
        fetchData(id = null) {
            window.scrollTo(0, 0);
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + "/projects",
                method: "GET",
                data: {},
                params: {
                    locale: this.locale,
                    status: "active",
                    paginate: 9,
                    page: this.currentPage,
                    category_id: id
                },
            };
            this.$axios(options)
                .then((res) => {
                    this.pgLoading = false;
                    this.rows = res.data.rows;

                    // info
                    this.info = res.data.info;

                    // pagination
                    this.currentPage = res.data.paginate.current_page;
                    //this.itemsPerPage = res.data.paginate.per_page;
                    this.resultCount = res.data.paginate.total;
                    this.nextPage = res.data.paginate.next_page;
                    this.prevPage = res.data.paginate.prev_page;
                })
                .catch(() => { })
                .finally(() => { });
        },

        setPage: function (pageNumber) {
            this.currentPage = pageNumber;
            this.fetchData();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
